import './EmailListItem.css';
/* src/EmailListItem.svelte generated by Svelte v3.23.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	is_function,
	listen,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "/web_modules/svelte/internal.js";

function create_if_block_1(ctx) {
	let span;
	let t0_value = /*thread*/ ctx[0].messages.length + "";
	let t0;
	let t1;

	return {
		c() {
			span = element("span");
			t0 = text(t0_value);
			t1 = text("x");
			attr(span, "class", "msgnum svelte-1152z23");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t0);
			append(span, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*thread*/ 1 && t0_value !== (t0_value = /*thread*/ ctx[0].messages.length + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (82:4) {#if thread.hasAttachments}
function create_if_block(ctx) {
	let t;

	return {
		c() {
			t = text("📎");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let div2;
	let div0;
	let span0;
	let t0_value = /*thread*/ ctx[0].participants.join(", ") + "";
	let t0;
	let t1;
	let t2;
	let span1;
	let t3_value = /*thread*/ ctx[0].subject + "";
	let t3;
	let t4;
	let div1;
	let t5;
	let t6_value = (/*thread*/ ctx[0].preview || "") + "";
	let t6;
	let mounted;
	let dispose;
	let if_block0 = /*thread*/ ctx[0].messages.length > 1 && create_if_block_1(ctx);
	let if_block1 = /*thread*/ ctx[0].hasAttachments && create_if_block(ctx);

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			span0 = element("span");
			t0 = text(t0_value);
			t1 = space();
			if (if_block0) if_block0.c();
			t2 = space();
			span1 = element("span");
			t3 = text(t3_value);
			t4 = space();
			div1 = element("div");
			if (if_block1) if_block1.c();
			t5 = space();
			t6 = text(t6_value);
			attr(span0, "class", "from svelte-1152z23");
			attr(span1, "class", "subject svelte-1152z23");
			attr(div0, "class", "mailtop svelte-1152z23");
			attr(div1, "class", "preview svelte-1152z23");
			attr(div2, "class", "item svelte-1152z23");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			append(div0, span0);
			append(span0, t0);
			append(div0, t1);
			if (if_block0) if_block0.m(div0, null);
			append(div0, t2);
			append(div0, span1);
			append(span1, t3);
			append(div2, t4);
			append(div2, div1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t5);
			append(div1, t6);

			if (!mounted) {
				dispose = listen(div2, "click", function () {
					if (is_function(/*onClick*/ ctx[1])) /*onClick*/ ctx[1].apply(this, arguments);
				});

				mounted = true;
			}
		},
		p(new_ctx, [dirty]) {
			ctx = new_ctx;
			if (dirty & /*thread*/ 1 && t0_value !== (t0_value = /*thread*/ ctx[0].participants.join(", ") + "")) set_data(t0, t0_value);

			if (/*thread*/ ctx[0].messages.length > 1) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(div0, t2);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*thread*/ 1 && t3_value !== (t3_value = /*thread*/ ctx[0].subject + "")) set_data(t3, t3_value);

			if (/*thread*/ ctx[0].hasAttachments) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(div1, t5);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*thread*/ 1 && t6_value !== (t6_value = (/*thread*/ ctx[0].preview || "") + "")) set_data(t6, t6_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { thread } = $$props; // jmap json object
	let { onClick } = $$props;

	$$self.$set = $$props => {
		if ("thread" in $$props) $$invalidate(0, thread = $$props.thread);
		if ("onClick" in $$props) $$invalidate(1, onClick = $$props.onClick);
	};

	return [thread, onClick];
}

class EmailListItem extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { thread: 0, onClick: 1 });
	}
}

export default EmailListItem;